import { createContext } from 'react';
export const UserContext = createContext();
export const CartContext = createContext();
export const PriceContext = createContext();
